// ダッシュボード画面
import React, { useState, useEffect, useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { Redirect } from 'react-router-dom';
import {
  useMediaQuery,
  Button,
  FormControl,
  Snackbar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import LoadingComponent from '../components/LoadingComponent';
import TeamContainer from '../components/TeamContainer';
import PersonalContainer from '../components/PersonalContainer';
import ConstructionSummaryTable from '../components/ConstructionSummaryTable';
import IndividualConstructionable from '../components/individualConstructionTable';
import FooterComponent from '../components/FooterComponent';
import {
  getTeamSummaryList,
  getPersonalSummaryList,
  getConstructionSummaryList,
  getIndividualConstructionSummaryList
} from '../apicalls/construction';
import {
  isLoggedIn,
  userRole,
  isUserId,
  isSortValue,
  constructionSortValue,
  constructionSortColumn,
  userPlanId,
  userMenuId
} from '../GlobalState';
import '../App.css';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { NotFoundPage } from './NotFoundPage';
import { useSetRecoilState } from 'recoil';
import { BasicSelect } from '../components/parts/input/BasicSelect';
import { CURRENCY_UNIT_LABELS, CURRENCY_UNITS } from '../const/Const';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 120
  },
  formControl1: {
    minWidth: 100
  }
}));

export const DashboardPage: React.FC = () => {
  const setUserId = useSetRecoilState(isUserId);
  const matches = useMediaQuery('(min-width:600px)');
  const classes = useStyles();
  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const nowYear = new Date().getFullYear();
  const nowMonth = new Date().getMonth() + 1;
  const lastYear = nowMonth === 1 ? nowYear - 1 : nowYear;
  const lastMonth = nowMonth === 1 ? 12 : nowMonth - 1;

  // ローカルストレージから取得する年月の値
  const startYearItem = localStorage.getItem('startYear');
  const startMonthItem = localStorage.getItem('startMonth');
  const endYearItem = localStorage.getItem('endYear');
  const endMonthItem = localStorage.getItem('endMonth');

  // ローカルストレージから取得した値がnullでない場合Int型に変換
  const savedStartYear =
    startYearItem !== null ? parseInt(startYearItem, 10) : null;
  const savedStartMonth =
    startMonthItem !== null ? parseInt(startMonthItem, 10) : null;
  const savedEndYear = endYearItem !== null ? parseInt(endYearItem, 10) : null;
  const savedEndMonth =
    endMonthItem !== null ? parseInt(endMonthItem, 10) : null;

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const [userPermission] = useRecoilState(userRole);
  const [userPlan] = useRecoilState(userPlanId);
  const [userId] = useRecoilState(isUserId);
  const [sortValue] = useRecoilState(isSortValue);
  const [sortOrder, setSortOrder] = useRecoilState(constructionSortValue);
  const [sortColumn, setSortColumn] = useRecoilState(constructionSortColumn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  // const [companyId, setConpanyId] = useState<number>(1);
  // const [progress, setProgress] = useState<number>(6);
  const [startYear, setStartYear] = useState<number>(
    savedStartYear ? savedStartYear : lastYear
  );
  const [startMonth, setStartMonth] = useState<number>(
    savedStartMonth ? savedStartMonth : lastMonth
  );
  const [endYear, setEndYear] = useState<number>(
    savedEndYear ? savedEndYear : nowYear
  );
  const [endMonth, setEndMonth] = useState<number>(
    savedEndMonth ? savedEndMonth : nowMonth
  );
  const [apiTeamSummaryData, setApiTeamSummaryData] = useState({
    start_date_year: lastYear,
    start_date_month: lastMonth,
    end_date_year: nowYear,
    end_date_month: nowMonth,
    target_sales_amount: 2000000000,
    target_cost_amount: 1500000000,
    target_gross_profit_amount: 500000000,
    target_gross_profit_rate_mean: 25,
    target_business_a_cases_num: 4000,
    target_business_b_cases_num: 5000,
    target_business_c_cases_num: 6000,
    target_construction_projects_num: 400,
    target_completed_projects_num: 300,
    actual_sales_amount: 1500000000,
    actual_cost_amount: 1200000000,
    actual_gross_profit_amount: 300000000,
    actual_gross_profit_rate_mean: 22,
    actual_business_a_cases_num: 3000,
    actual_business_b_cases_num: 4000,
    actual_business_c_cases_num: 5000,
    actual_construction_projects_num: 300,
    actual_completed_projects_num: 250,
    max_target_value: 0,
    monthly: []
  });
  const [apiPersonalSummaryData, setApiPersonalSummaryData] = useState([]);
  const [apiConstructionSummaryData, setApiConstructionSummaryData] = useState(
    []
  );
  const [apiIndividualConstructionData, setApiIndividualConstructionData] =
    useState([]);
  const teamContainerData = apiTeamSummaryData;
  const personalContainerData = apiPersonalSummaryData;
  const constructionSummaryTableData = apiConstructionSummaryData;
  const indivualConstructionTableData = apiIndividualConstructionData;
  const [userMenu] = useRecoilState<any>(userMenuId);

  const years = [
    2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020,
    2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030
  ];
  const monthes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const [currency, setCurrency] = useState<number>(CURRENCY_UNITS.COMMA);

  const getListOfTeamSummary = useCallback(() => {
    getTeamSummaryList(6, startYear, startMonth, endYear, endMonth).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setApiTeamSummaryData(data.data);
              setLoading(false);
            }
          }
        }
      }
    );
  }, [changeLoggedInData, endMonth, endYear, startMonth, startYear]);
  console.log('userId', userId);
  const getListOfPersonalSummary = useCallback(() => {
    getPersonalSummaryList(6, startYear, startMonth, endYear, endMonth).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setApiPersonalSummaryData(data.data);
              setLoading(false);
            }
          }
        }
      }
    );
  }, [changeLoggedInData, endMonth, endYear, startMonth, startYear]);

  const getListOfConstructionSummary = useCallback(() => {
    getConstructionSummaryList(
      sortColumn,
      sortOrder,
      6,
      startYear,
      startMonth,
      endYear,
      endMonth
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setApiConstructionSummaryData(data.data);
            setLoading(false);
          }
        }
      }
    });
  }, [
    changeLoggedInData,
    endMonth,
    endYear,
    startMonth,
    startYear,
    sortColumn,
    sortOrder
  ]);
  const getListOfIndividualConstructionSummary = useCallback(() => {
    userId != null &&
      getIndividualConstructionSummaryList(
        userId,
        startYear,
        startMonth,
        endYear,
        endMonth
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setApiIndividualConstructionData(data.data);
              setLoading(false);
            }
          }
        }
      });
    // 表示を押すまで反映されないように、Year,Monthを除外しない
  }, [changeLoggedInData, userId]);

  // ローカルストレージに年月を保存
  const saveUserDashboardDate = (
    startYear: number,
    startMonth: number,
    endYear: number,
    endMonth: number
  ) => {
    localStorage.setItem('startYear', startYear.toString());
    localStorage.setItem('startMonth', startMonth.toString());
    localStorage.setItem('endYear', endYear.toString());
    localStorage.setItem('endMonth', endMonth.toString());
  };

  // 年月の初期値の設定
  useEffect(() => {
    setStartYear(savedStartYear !== null ? savedStartYear : lastYear);
    setStartMonth(savedStartMonth !== null ? savedStartMonth : lastMonth);
    setEndYear(savedEndYear !== null ? savedEndYear : nowYear);
    setEndMonth(savedEndMonth !== null ? savedEndMonth : nowMonth);
  }, []);

  // 年月が変更された場合にローカルストレージに保存
  useEffect(() => {
    if (
      startYear !== undefined &&
      startMonth !== undefined &&
      endYear !== undefined &&
      endMonth !== undefined
    ) {
      saveUserDashboardDate(startYear, startMonth, endYear, endMonth);
    }
  }, [startYear, startMonth, endYear, endMonth]);

  useEffect(() => {
    getListOfTeamSummary();
    getListOfPersonalSummary();
    // getListOfConstructionSummary();
  }, []);
  useEffect(() => {
    getListOfConstructionSummary();
  }, [sortOrder, sortColumn]);
  useEffect(() => {
    getListOfIndividualConstructionSummary();
  }, [userId, getListOfIndividualConstructionSummary]);

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  if (userMenu == 'Storage') {
    return (
      <Redirect
        to={{
          pathname: '/constructions'
        }}
      />
    );
  }

  if (userPermission === 3 || userPlan === 3) {
    return <NotFoundPage />;
  }

  return (
    <div>
      <AppBarComponent patternName='dashboard' />
      {loading === true ||
      userPermission === undefined ||
      userPlan === undefined ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <div
            style={{
              padding: !matches ? 15 : 20,
              paddingBottom: !matches ? 10 : 15,
              justifyContent: 'space-between',
              overflow: 'hidden',
              display: 'flex',
              flexWrap: 'wrap'
            }}
          >
            <div
              style={{
                fontSize: !matches ? 20 : 24,
                fontWeight: 'bold',
                marginBottom: 5
              }}
            >
              目標と実績（全体）
            </div>
            <div
              className='top-bar-container'
              style={{
                overflow: 'hidden',
                display: 'flex',
                flexWrap: 'wrap'
              }}
            >
              <div>
                <div
                  style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 5 }}
                >
                  開始年月
                </div>
              </div>

              <div
                className='select-div'
                style={{ marginRight: 20, marginBottom: 5 }}
              >
                <div style={{ paddingLeft: 5 }}>
                  <FormControl className={classes.formControl}>
                    <BasicSelect
                      value={startYear}
                      onChange={e => {
                        setStartYear(parseInt(e.target.value));
                      }}
                      inputProps={{ 'aria-label': 'age' }}
                      disableUnderline
                    >
                      {years.map(i => (
                        <option value={i}>{i}年</option>
                      ))}
                    </BasicSelect>
                  </FormControl>
                </div>
              </div>

              <div className='select-div' style={{ marginBottom: 5 }}>
                <div style={{ paddingLeft: 5 }}>
                  <FormControl className={classes.formControl1}>
                    <BasicSelect
                      value={startMonth}
                      onChange={e => {
                        setStartMonth(parseInt(e.target.value));
                      }}
                      inputProps={{ 'aria-label': 'age' }}
                      disableUnderline
                    >
                      {monthes.map(i => (
                        <option value={i}>{i}月</option>
                      ))}
                    </BasicSelect>
                  </FormControl>
                </div>
              </div>

              <div>
                <div
                  style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 5 }}
                >
                  ~
                </div>
              </div>

              <div>
                <div
                  style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 5 }}
                >
                  終了年月
                </div>
              </div>

              <div
                className='select-div'
                style={{ marginRight: 20, marginBottom: 5 }}
              >
                <div style={{ paddingLeft: 5 }}>
                  <FormControl className={classes.formControl}>
                    <BasicSelect
                      value={endYear}
                      onChange={e => {
                        setEndYear(parseInt(e.target.value));
                      }}
                      inputProps={{ 'aria-label': 'age' }}
                      disableUnderline
                    >
                      {years.map(i => (
                        <option value={i}>{i}年</option>
                      ))}
                    </BasicSelect>
                  </FormControl>
                </div>
              </div>

              <div
                className='select-div'
                style={{ marginRight: 20, marginBottom: 5 }}
              >
                <div style={{ paddingLeft: 5 }}>
                  <FormControl className={classes.formControl1}>
                    <BasicSelect
                      value={endMonth}
                      onChange={e => {
                        setEndMonth(parseInt(e.target.value));
                      }}
                      inputProps={{ 'aria-label': 'age' }}
                      disableUnderline
                    >
                      {monthes.map(i => (
                        <option value={i}>{i}月</option>
                      ))}
                    </BasicSelect>
                  </FormControl>
                </div>
              </div>

              <div style={{ marginRight: 20, marginBottom: 5 }}>
                <Button
                  style={{ backgroundColor: '#007DFF' }}
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    getListOfTeamSummary();
                    getListOfPersonalSummary();
                    getListOfConstructionSummary();
                    setApiIndividualConstructionData([]);
                    setUserId(0);
                  }}
                >
                  表示
                </Button>
              </div>

              <div className='select-div' style={{ marginBottom: 5 }}>
                <div style={{ paddingLeft: 5 }}>
                  <FormControl className={classes.formControl1}>
                    <BasicSelect
                      value={currency}
                      onChange={e => {
                        setCurrency(parseInt(e.target.value));
                      }}
                      inputProps={{ 'aria-label': 'age' }}
                      disableUnderline
                    >
                      {Object.entries(CURRENCY_UNIT_LABELS).map(
                        ([key, label]) => (
                          <option key={key} value={key}>
                            {label}
                          </option>
                        )
                      )}
                    </BasicSelect>
                  </FormControl>
                </div>
              </div>
            </div>
          </div>

          <div className='top-below-container'>
            <div style={{ fontSize: 14 }}>期間</div>
            <div style={{ fontWeight: 'bold', fontSize: 24 }}>
              {startYear}年{startMonth}月~{endYear}年{endMonth}月
            </div>
          </div>
          <div></div>
          <TeamContainer
            start_date_year={teamContainerData.start_date_year}
            start_date_month={teamContainerData.start_date_month}
            end_date_year={teamContainerData.end_date_year}
            end_date_month={teamContainerData.end_date_month}
            target_sales_amount={teamContainerData.target_sales_amount}
            target_cost_amount={teamContainerData.target_cost_amount}
            target_gross_profit_amount={
              teamContainerData.target_gross_profit_amount
            }
            target_gross_profit_rate_mean={
              teamContainerData.target_gross_profit_rate_mean
            }
            target_business_a_cases_num={
              teamContainerData.target_business_a_cases_num
            }
            target_business_b_cases_num={
              teamContainerData.target_business_b_cases_num
            }
            target_business_c_cases_num={
              teamContainerData.target_business_c_cases_num
            }
            target_construction_projects_num={
              teamContainerData.target_construction_projects_num
            }
            target_completed_projects_num={
              teamContainerData.target_completed_projects_num
            }
            actual_sales_amount={teamContainerData.actual_sales_amount}
            actual_cost_amount={teamContainerData.actual_cost_amount}
            actual_gross_profit_amount={
              teamContainerData.actual_gross_profit_amount
            }
            actual_gross_profit_rate_mean={
              teamContainerData.actual_gross_profit_rate_mean
            }
            actual_business_a_cases_num={
              teamContainerData.actual_business_a_cases_num
            }
            actual_business_b_cases_num={
              teamContainerData.actual_business_b_cases_num
            }
            actual_business_c_cases_num={
              teamContainerData.actual_business_c_cases_num
            }
            actual_construction_projects_num={
              teamContainerData.actual_construction_projects_num
            }
            actual_completed_projects_num={
              teamContainerData.actual_completed_projects_num
            }
            currency={currency}
            max_target_value={teamContainerData.max_target_value}
            graphStatus={teamContainerData.monthly}
          />
          <div style={{ height: 15, backgroundColor: '#CCCCCC' }} />
          <PersonalContainer
            currency={currency}
            graphStatus={personalContainerData}
          />

          <IndividualConstructionable
            currency={currency}
            graphStatus={indivualConstructionTableData}
          />
          <ConstructionSummaryTable
            currency={currency}
            graphStatus={constructionSummaryTableData}
          />
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
